export default __webpack_public_path__ + "19c206650ad45738a9688022eb945942.png";